import Translate, { Message } from "../../messages/GeralMessages";

export const FedexHelper = {
    ProcessEvents: function (tracking, events, dateAndTimes) {
        let progress = 0;
        for (let s in tracking) {
            events[0].done = true;

            if (tracking[s].derivedStatus == "Label created") {
                events[0].description = "";
                events[0].title = "Etiqueta criada";
                events[0].icon = "fa fa-map-pin fa-2x";
                events[0].done = true;
                events[0].date = tracking[s].date;
                progress = 25;
            } if (tracking[s].eventType == "PX" || tracking[s].eventType == "PU" || tracking[s].eventType == "AP" || tracking[s].eventType == "IP") {
                events[1].description = "Estamos com seu pacote";
                events[1].title = "Coletado";
                events[1].icon = "si si-social-dropbox fa-2x";
                events[1].done = true;
                events[1].date = tracking[s].date;
                progress = 25;
            } if (tracking[s].eventType == "OC") {
                events[1].description = "Documentos gerados";
                events[1].title = "Processando seu pedido";
                events[1].icon = "far fa-file-alt fa-2x";
                events[1].done = true;
                events[1].date = tracking[s].date;
                progress = 25;
            } else if (tracking[s].eventType == "CA" || tracking[s].eventType == "LC" || tracking[s].eventType == "DO" || tracking[s].eventType == "RD" || tracking[s].eventType == "RG" || tracking[s].eventType == "RP") {
                events[1].description = tracking[s].eventDescription;
                events[1].title = "Cancelado, expirado ou com erro";
                events[1].icon = "fa fa-exclamation-triangle fa-2x";
                events[1].date = tracking[s].date;
                events[1].done = true;
                progress = 50;
            } else if (tracking[s].eventType == "AF") {
                events[2].description = tracking[s].eventDescription;
                events[2].title = "A caminho";
                events[2].icon = "fa fa-shipping-fast fa-2x";
                events[2].date = tracking[s].date;
                progress = 50;
            } else if (tracking[s].eventType == "IT") {
                events[2].description = `${tracking[s].scanLocation.city} - ${tracking[s].scanLocation.stateOrProvinceCode}`;
                events[2].title = "A caminho";
                events[2].icon = "fa fa-shipping-fast fa-2x";
                events[2].date = tracking[s].date;
                events[2].done = true;
                progress = 50;
            }
            else if (
                tracking[s].eventType == "OF" ||
                tracking[s].eventType == "AR" ||
                tracking[s].eventType == "AA" ||
                tracking[s].eventType == "IX" ||
                tracking[s].eventType == "LO" ||
                tracking[s].eventType == "OX" ||
                tracking[s].eventType == "PF" ||
                tracking[s].eventType == "DP" ||
                tracking[s].eventType == "CP" ||
                tracking[s].eventType == "AX" ||
                tracking[s].eventType == "CH" ||
                tracking[s].eventType == "CC" ||
                tracking[s].eventType == "FD" ||
                tracking[s].eventType == "HL" ||
                tracking[s].eventType == "HA" ||
                tracking[s].eventType == "RC" ||
                tracking[s].eventType == "SP" ||
                tracking[s].eventType == "TR" ||
                tracking[s].eventType == "CA" ||
                tracking[s].eventType == "CP" ||
                tracking[s].eventType == "EA" ||
                tracking[s].eventType == "OD" ||
                tracking[s].eventType == "DCIF" ||
                tracking[s].eventType == "SF"
            ) {
                events[3].description = tracking[s].eventDescription;
                events[3].title = "Saiu para entrega";
                events[3].icon = "fa fa-shipping-fast fa-2x";
                events[3].date = tracking[s].date;
                events[3].done = true;
                progress = 70;


            } else if (tracking[s].eventType == "DL") {
                events[4].description = `${Translate(Message.Delivered)} - ${tracking[s].scanLocation.city} - ${tracking[s].scanLocation.stateOrProvinceCode}`;
                events[4].title = "Entregue";
                events[4].icon = "fa fa-flag-checkered fa-2x";
                events[4].date = tracking[s].date;
                events[4].done = true;
                progress = 100;
            } else if (
                tracking[s].eventType == "DE" ||
                tracking[s].eventType == "DD" ||
                tracking[s].eventType == "DE" ||
                tracking[s].eventType == "SE" ||
                tracking[s].eventType == "DY" ||
                tracking[s].eventType == "CC" ||
                tracking[s].eventType == "CD"
            ) {
                events[1].description = tracking[s].eventDescription;
                events[1].title = "Erro";
                events[1].icon = "si si-social-dropbox fa-2x";
                events[1].date = tracking[s].date;
                events[1].done = true;
                progress = 15;
            }
        }


        const pickup = dateAndTimes.filter(x => x.type == "ACTUAL_PICKUP");

        if (pickup.length > 0 && events[1].icon.length == 0) {
            events[1].description = "Estamos com seu pacote";
            events[1].title = "Coletado";
            events[1].icon = "";
            events[1].date = pickup[0].dateTime;
            // progress = 15;
        }

        return { events, progress };
    }
}